import React, { Component } from 'react';
import { Col,Row } from 'react-bootstrap';
import AdminLayout from './AdminLayout';
import AlarmInfoDetail from '../components/admin/AlarmInfoDetail';
import '../css/style.css';
import '../components/Home.css';

class AlarmInfoLayout extends Component {

    render(){
        return (
            <AdminLayout eventKey="5">
                <Row>
                    <Col xl={12}>
                    <AlarmInfoDetail />
                    </Col>
                </Row>
            </AdminLayout>              
        );
    }

}

export default AlarmInfoLayout;